import { render, staticRenderFns } from "./SeccionesComponent.vue?vue&type=template&id=6fbf9856"
import script from "./SeccionesComponent.vue?vue&type=script&lang=js"
export * from "./SeccionesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports